export default __webpack_public_path__ + "static/media/Lisa.Keefauver_MSW_AHV_In_Moms_We_Trust.ded56303.jpg";